// extracted by mini-css-extract-plugin
module.exports = {"title":"a10a3f92e9--title--ARRNf","row":"a10a3f92e9--row--toLeq","key":"a10a3f92e9--key--aIKBJ","value":"a10a3f92e9--value--BEho1","warning":"a10a3f92e9--warning--nsFvl"};